export const cupTeamName = (team: { tc_name: string | null; ext_name: string | null }): string =>
  team.tc_name || team.ext_name || 'Unnamed team'

export const TIE_ROUND_LABELS: Record<string, string> = {
  qualification_round_1: 'Qualifying Round 1',
  qualification_round_2: 'Qualifying Round 2',
  qualification_final: 'Qualifying Final',
  world_group_1: 'World Group I',
  world_group_2: 'World Group II',
  group_stage: 'Group Stage',
  round_robin: 'Round Robin',
  quarterfinal: 'Quarterfinal',
  semifinal: 'Semifinal',
  final: 'Final',
  day_1: 'Day 1',
  day_2: 'Day 2',
  day_3: 'Day 3',
}

const titleCase = (code: string): string =>
  code
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')

export const roundLabel = (value: string | null): string | null => {
  if (!value) return null
  if (TIE_ROUND_LABELS[value]) return TIE_ROUND_LABELS[value]
  return value === value.toLowerCase() ? titleCase(value) : value
}
